var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse, _polygon3, _path27, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _rect1, _rect10, _rect11, _circle2, _rect12, _ellipse2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmnoresults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4_copy",
    "data-name": "Layer 4 copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 534.65 641.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-25{fill:#006aea;}.cls-2{fill:#d6e0ea;}.cls-3{fill:#4d4d4d;}.cls-4{fill:#e1bf7d;}.cls-5{fill:#ffeab9;}.cls-6{fill:#ebf6fc;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:#d1d4d4;}.cls-9{fill:#9cc8ff;}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:#4296cf;stroke:#4296cf;}.cls-11,.cls-12,.cls-13,.cls-18,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25{stroke-miterlimit:10;}.cls-12,.cls-13,.cls-14{fill:#ffe28e;}.cls-12{stroke:#ffeab9;}.cls-13{stroke:#ffe28e;}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#radial-gradient);}.cls-17{fill:#00479b;}.cls-18{fill:#deb87d;stroke:#deb87d;}.cls-19,.cls-22{fill:#fff;}.cls-20{fill:url(#linear-gradient-4);}.cls-21{fill:#f8fdff;stroke:#c1c1c1;}.cls-22{stroke:#b5b5b5;}.cls-23,.cls-24{fill:none;}.cls-23{stroke:#00479b;}.cls-24,.cls-25{stroke:#10509d;}.cls-24{stroke-width:13px;}.cls-25{stroke-width:4px;}.cls-26{fill:#999;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 851.1,
    y1: 309.85,
    x2: 800.73,
    y2: 309.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#b9d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a4ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a0caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#add2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c3ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 912.13,
    y1: 322.1,
    x2: 832.89,
    y2: 322.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 801.15,
    y1: 615.13,
    x2: 852.26,
    y2: 615.13,
    gradientTransform: "translate(34.23 -55) rotate(4.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#75a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#235fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03438f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 866.14,
    cy: 266.11,
    fx: 881.2655488254924,
    r: 16.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffecb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fae6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f6e0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f6cc8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 945.09,
    y1: 322.82,
    x2: 877.7,
    y2: 316.51,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566,272.18c2.34,12.11-7.91,16.38-24.72,47.75C527.88,345,528.4,353.5,523.23,359.7a20.89,20.89,0,0,1-4.24,3.77c-15.7,11.82-29.65,42.36-49,52.08-25.34,12.72-69.13-5.68-75.66-32.56a3.91,3.91,0,0,1-.4-1.93c7.14-87.92,26.7-106.18,26.7-106.18,11-10.25,39.12-16.63,95.38-29.39a40.3,40.3,0,0,1,11.39-1C544.19,245.43,563.17,257.3,566,272.18Z",
    transform: "translate(-393.93 -44.36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M576,272.18c2.34,12.11-7.91,16.38-24.72,47.75C537.88,345,538.4,353.5,533.23,359.7a20.89,20.89,0,0,1-4.24,3.77c-15.7,11.82-29.65,42.36-49,52.08-25.34,12.72-69.13-5.68-75.66-32.56a3.91,3.91,0,0,1-.4-1.93c7.14-87.92,26.7-106.18,26.7-106.18,11-10.25,39.12-16.63,95.38-29.39a40.3,40.3,0,0,1,11.39-1C554.19,245.43,573.17,257.3,576,272.18Z",
    transform: "translate(-393.93 -44.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M879,184.9l29.54,4.74a9.58,9.58,0,0,1,8.35,4.81,9.79,9.79,0,0,1-2.47,11.88,84.38,84.38,0,0,0-12.76,10.79c-9.08,9.41-10.29,15.15-14,15.65-4.4.6-11.44-6.35-23.11-38.33Z",
    transform: "translate(-393.93 -44.36)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M879,184.85l29.56,4.73a10.9,10.9,0,0,1,5.56,1.59c5.76,3.36,5.94,12.05,1.24,16.52a111.47,111.47,0,0,0-19.5,23.51c-2.1,3.54-6,7.1-10.71,5.76-11.74-3-19.22-31.26-22.33-41.87l-.42-1.58c5.48-3,11.08-5.94,16.6-8.66Zm0,.11c-3.83,3.26-9.6,8-13.41,11l.72-2.2c2.84,6,6.12,12.86,9.25,18.74a102.77,102.77,0,0,0,6.55,10.76c1.43,1.82,3.1,4.14,5,5,0,0,.1.06.09,0v0c-.1,0-.25,0-.34.07,3-3,5.62-7.4,9-10.62a69.25,69.25,0,0,1,17.47-12.73c4.72-2.94,5.4-10.34.57-13.63a9.6,9.6,0,0,0-5.37-1.77L879,185Z",
    transform: "translate(-393.93 -44.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829.23,364.32c-3.38,8-7,6.56-10.79.87-.18-2.65-.52-6.93-1.16-12.23-.88-7.42-1.36-8.71-1.79-14-.14-1.81-.07-1.49-.37-14.06-.19-7.9-.26-9.55-.28-13.34,0-4.22,0-7.71.07-10.09l22.31.71c-.06,1.87-.15,4.72-.25,8.2-.26,9.47-.22,10.58-.41,13.57a113.58,113.58,0,0,1-1.74,13.87c-1.25,6.56-2.17,8-3.7,15.27C830.1,357.9,829.54,361.86,829.23,364.32Z",
    transform: "translate(-393.93 -44.36)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M918,385h.12a6.42,6.42,0,0,0,6.42-6.24c.05-1.74.13-3.68.24-5.78.4-7.31.82-8.6.89-13.86,0-1.78,0-1.45-.62-13.76-.37-7.73-.42-9.34-.67-13-.08-1.17-.16-2.28-.24-3.32a6.4,6.4,0,0,0-7-5.87l-10.74,1.09a6.41,6.41,0,0,0-5.73,7c.06.52.11,1.05.17,1.59,1,9.23,1,10.32,1.42,13.22a103.64,103.64,0,0,0,2.85,13.41c1.8,6.32,2.88,7.66,5,14.64.69,2.24,1.25,4.28,1.7,6.07A6.4,6.4,0,0,0,918,385Z",
    transform: "translate(-393.93 -44.36)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "438.26 300.76 423.86 301.22 425.72 230.3 440.12 229.84 438.26 300.76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M832.49,345.43c-4.87.22-9.79.42-14.69.57h-.25l-.19-.44a70,70,0,0,1-3-8.95c-.81-3-1.47-5.95-2-8.92a142.87,142.87,0,0,1-2.16-17.8c-.18-3-.3-5.92-.32-8.88,0-1.48,0-3,0-4.44s0-2.95.19-4.43A26.92,26.92,0,0,1,815.2,279a23.77,23.77,0,0,1,4-4.33l.42-.41,14.39-.46.44.44a31.08,31.08,0,0,1,8.84,5.08,19.8,19.8,0,0,1,4.71,5.41,13.1,13.1,0,0,1,1.83,8l-.16,2.59a126.93,126.93,0,0,1-3.08,20.11,95.88,95.88,0,0,1-5.87,17.49,56.53,56.53,0,0,1-3.8,7.08A23.36,23.36,0,0,1,832.49,345.43Zm-.6-.6c-1.54-4.54-2.77-8.52-4-12.33l-3.34-10.65c-2-6.66-3.72-12.52-4.94-18a85.51,85.51,0,0,1-2.14-15.36l-.05-1.83a6.49,6.49,0,0,1,.12-1.82,7,7,0,0,1,2.06-3.44,20.59,20.59,0,0,1,4.94-3.46,55.61,55.61,0,0,1,9.07-3.78l.44.43-14.4.45.41-.41a23.77,23.77,0,0,1,3.8,4.54,27.59,27.59,0,0,1,2.39,4.49,26.86,26.86,0,0,1,2,8.93c.09,1.48,0,3,0,4.43s-.13,3-.22,4.43c-.18,3-.45,5.9-.78,8.85A144.15,144.15,0,0,1,824.13,328c-.7,2.94-1.52,5.88-2.48,8.81a68.69,68.69,0,0,1-3.44,8.78l-.44-.43C822.48,345,827.15,344.91,831.89,344.83Z",
    transform: "translate(-393.93 -44.36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M857.21,360.26l26.22-.75q-4.3,24.78-8.63,49.56l-15.68,2.58Q858.16,386,857.21,360.26Z",
    transform: "translate(-393.93 -44.36)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M856.9,360c8.89-.33,17.84-.64,26.76-.89l.19.5,20.51,54.64,7.52,20-48,6.56-46.75,6.4,12.41-34.48a206.61,206.61,0,0,1,14.55-32c4.21-7.56,8.72-14.21,12.78-20.74Zm.62.58a117.23,117.23,0,0,0,31.16,50l-34.35-28.09,15.62-3-24.7,24.46L883,359.44l.43.49c-8.64.26-17.25.45-25.93.62Z",
    transform: "translate(-393.93 -44.36)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M820.75,598.14l24.31,3.07,23.85-223.35-16.18,6.88q-11.21,58.58-20.45,122.16Q825.55,553.66,820.75,598.14Z",
    transform: "translate(-393.93 -44.36)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M821.06,597.9l24,3.08-.26.2c1.93-18.62,4.07-37.22,5.23-55.91,2.13-36.83,0-75.84,4.64-112.45,1.15-9.3,4.83-18.58,8.06-27.38a96.28,96.28,0,0,0,3.94-13.7c.95-4.6,1.33-9.27,1.93-13.91l.39.29-8.13,3.33-8.11,3.4.07-.09c-1.73,8.83-3.3,17.68-4.78,26.55L847,418c-1.63,7.26.9,14.47,3.86,21.18s5.42,13.84,3.77,21.06C848,500.1,839.83,539.83,827.9,578.6c-1.16,3.6-3,9.48-4.34,13.06-.8,2.39-1.76,3.75-2.5,6.24Zm-.61.48c-1.58-9-2.16-18.65-2.72-27.77-1.79-36.32.87-72.65,6.23-108.52l1-6.7c1.12-13.06,14.24-19.95,19.33-31,1.76-3.73,2.32-9.15,3.19-13.13,1.5-7.67,3.69-18.9,5.09-26.5v-.06l.07,0,8.07-3.48,8-3.55.43-.19,0,.48c-1.06,9.42-1.57,18.75-.09,28.23,1.3,9.3,2.95,19.12,2.1,28.46-2.41,26.95-8.75,56.52-14.26,83.19-5.76,27.55-8.68,55.51-11.65,83.46l0,.24-.24,0-24.58-3.06Z",
    transform: "translate(-393.93 -44.36)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M852,372l39,1.1,2.12-80.93c-2.21-.26-5.29-.55-9-.69-3.28-.12-5.82-.08-10.07,0-5.79.1-6.24.24-9.33.22a104.82,104.82,0,0,1-10.59-.62Z",
    transform: "translate(-393.93 -44.36)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M852.19,371.78l19.37.59c6.46.2,13,.32,19.42.47l-.22.22c0-3.37.18-6.75.14-10.12a90.93,90.93,0,0,0-.71-10.14,114.87,114.87,0,0,0-4.73-20.37c-2.15-6.81-4.61-13.62-6.58-20.42a128.19,128.19,0,0,1-4.27-20.36L891,310.5c-1.39.14-2.77.29-4.14.39-.68.05-1.36.11-2,.14s-1.33.05-2.08.16c-2.93.36-5.79.57-8.72.66-1.55.07-3,.12-4.5.13l-1.31,0-1.57,0c-1.09,0-2.07-.06-3-.13A78.54,78.54,0,0,1,852,310.14l21.32-18.61c-.55,2.8-1.1,5.61-1.79,8.46s-1.35,5.73-2.14,8.68c-1.51,5.89-3.3,12-5.17,18.54s-3.91,13.42-5.93,20.81S854.29,363.24,852.19,371.78Zm-.38.36c-1.74-4.95-3.38-10.62-5.06-16.7s-3.35-12.68-4.87-19.66-3-14.33-4.11-21.93c-.62-3.8-1.14-7.66-1.62-11.55s-.88-7.83-1.25-11.78L833.26,273l23-1.13c2.7-.13,5.35-.3,7.94-.48l1.83-.13.87-.08,1.13-.06c1.72-.11,3.55-.15,5.25-.14,3.57.07,7.22.31,10.8.67.87.06,1.85.27,2.78.42s1.89.34,2.82.52c1.88.35,3.74.74,5.59,1.13l19,3.94-2.64,14.91a128,128,0,0,1-5.34,20.11c-2.32,6.69-5.13,13.37-7.64,20a115,115,0,0,0-5.78,20.1A90.85,90.85,0,0,0,891.58,363c-.21,3.37-.26,6.74-.38,10.11v.22H891c-6.52-.22-13-.46-19.54-.63Z",
    transform: "translate(-393.93 -44.36)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M866.13,299.69",
    transform: "translate(-393.93 -44.36)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "506.32 580.83 481.89 581.03 483.63 361.94 508.06 361.74 506.32 580.83"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.43,625.37l-24.62.28h-.23l0-.26c-2.72-36.32-3.62-73.18-4-109.58,0-27.4-.89-54.83,1.66-82.15a219,219,0,0,1,4.15-27.61h.2c.12,0,24.45-.22,24.56-.21a65.79,65.79,0,0,1,5.46,14.25,118.43,118.43,0,0,1,3.9,28.53,1662,1662,0,0,1-11,176.75Zm-.36-.36c-5-60.67-8.72-119.15-8.21-179.27a102.43,102.43,0,0,1,4.33-26.25,68,68,0,0,1,5.54-13.39l.26.26-24.43.2.25-.25c1,4.57,1.67,9.14,2.26,13.71a349,349,0,0,1,2.55,41.1c-.14,41-1.26,82.22-3.54,123.22-.81,13.21-1.74,27.92-3,41.06l-.26-.26,24.26-.13Z",
    transform: "translate(-393.93 -44.36)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M800.41,255.38",
    transform: "translate(-393.93 -44.36)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M783.47,238.64",
    transform: "translate(-393.93 -44.36)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M898.21,340.86",
    transform: "translate(-393.93 -44.36)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M839,274.35",
    transform: "translate(-393.93 -44.36)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M808.56,254.49",
    transform: "translate(-393.93 -44.36)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M794.77,620.12c-5.83,7.56-8.75,11.34-7.21,13.83,3.65,5.91,28.42,3.47,43.39-8.7,3.69-3,10.17-8.27,8.64-14.27-1.6-6.3-11.45-11-19.32-10.92C810.15,600.18,804,608.22,794.77,620.12Z",
    transform: "translate(-393.93 -44.36)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M852.63,274.85c1.26,6.07,4.37,8.08,5.12,8.52,5.52,3.28,15.37-.11,21.9-10.28a30.83,30.83,0,0,1-2.07-3.72,26.8,26.8,0,0,1-2.33-7,46.07,46.07,0,0,1-.53-6.44c-.08-1.86-.1-3.73-.11-4.87,0-1.41,0-2.6,0-3.46h-16c.07.85.15,2,.22,3.46.07,1.72.15,3.35.1,5.09a34.77,34.77,0,0,1-.64,6c0,.1,0,.21-.07.33a31.4,31.4,0,0,1-2.94,7.57C854.65,271.37,853.77,273,852.63,274.85Z",
    transform: "translate(-393.93 -44.36)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M847.18,211.57c-.91,7.08-1.51,12.1,0,18a33,33,0,0,0,5.73,11.46c3.78,5.43,6.38,9.17,10.63,9.84s7.49-1.93,13.21-6.31c3.67-2.81,7.66-5.87,10.93-11.81,2.57-4.66,3.41-8.78,4.48-14,1.76-8.59,2.82-13.74,1.56-19.1-2.39-10.16-11.76-15.44-18.9-16.6s-17.73.95-23.22,9.84C849.07,197,848.44,201.88,847.18,211.57Z",
    transform: "translate(-393.93 -44.36)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.9,174.77a50,50,0,0,1,19.58,3.08c7.71,2.85,12.52,6.76,16.36,9.88,2.62,2.13,3.43,3.94,5.07,7.34,1,2.14,3.15,4.4,3.09,5.06l-.63,6c-.33,3.22-3.34,5.34-6.81,5h-.08c-2.25-.23-3.76.25-6,.71a64.75,64.75,0,0,1-9.84,1,33.39,33.39,0,0,1-13.8-2,25.89,25.89,0,0,1-9.89-6.26c-3-3.17-3-5-6.35-9.43a39.46,39.46,0,0,0-3.18-3.67,5.93,5.93,0,0,1-1-7.46c1.21-2.11,2.41-4.23,3.61-6.34Z",
    transform: "translate(-393.93 -44.36)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M912.21,669.26c1.63,9.39,2.45,14.08-.07,15.59-6,3.6-26.78-9.88-34.34-27.54-1.87-4.36-5.14-12-1-16.63,4.36-4.87,15.28-4.56,22.19-.89C907.9,644.51,909.64,654.5,912.21,669.26Z",
    transform: "translate(-393.93 -44.36)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M857.22,352l0-.09c.56-2.72,3-4.5,5.16-3.83s5.08,1.51,8.23,2.38c7.52,2.07,8.91,2.17,14.28,3.83,1.82.56,1.48.5,13.94,4.95,7.83,2.8,9.47,3.36,13.21,4.76,2.33.87,4.42,1.67,6.23,2.37,2,.79,3,3.45,2.07,5.91l-3,8.38c-.88,2.45-3.22,3.77-5.22,3l-4.39-1.78c-9.26-3.74-10.37-4.12-13.26-5.39-6.54-2.86-11.45-5.55-13.23-6.53-6.15-3.44-7.34-4.7-14.12-8.62-3.05-1.76-5.75-3.2-7.91-4.31A4.5,4.5,0,0,1,857.22,352Z",
    transform: "translate(-393.93 -44.36)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M807.18,302.59l.08,0c2.47-1.06,5.21,0,5.91,2.25s1.63,5.2,2.7,8.39c2.55,7.61,3.25,8.85,4.93,14.39.57,1.87.43,1.54,3.85,14.73,2.15,8.28,2.62,10,3.59,14,1.5,6.08,1.57,6.38,1.6,6.68.2,1.73-.14,4.53-3.46,8.43l-2.71.77c-4-.26-8.91-1.23-10.93-4.73-.3-.53-.08-.41-1-4.77-2.2-10-2.51-11.2-3.13-14.39-1.38-7.22-2-12.94-2.19-15-.72-7.21-.38-8.94-1.06-17-.3-3.6-.66-6.73-1-9.21A4.45,4.45,0,0,1,807.18,302.59Z",
    transform: "translate(-393.93 -44.36)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M833,383.21",
    transform: "translate(-393.93 -44.36)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 450.91,
    cy: 296.72,
    rx: 7.39,
    ry: 7.69
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "511.43 317.01 530.8 315.04 523.5 233.65 504.13 235.63 511.43 317.01"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M905.6,361.09c6.38-.72,12.72-1.41,19.08-2.06l-.33.41a96.52,96.52,0,0,1-3.72-9.93q-1.62-5-2.87-10-2.55-10-4.13-20.14c-.53-3.37-1-6.75-1.39-10.13-.2-1.7-.39-3.39-.55-5.08s-.36-3.39-.39-5.09a38.26,38.26,0,0,1,1.05-10.35,35.13,35.13,0,0,1,1.74-5.29,26.82,26.82,0,0,1,3-5.39l.41.34-19.36,2,.33-.4a40.54,40.54,0,0,1,8.28,4,19.21,19.21,0,0,1,4.62,3.93,9.88,9.88,0,0,1,2.09,4.08,9.76,9.76,0,0,1,.26,2.17l.11,2.2a131.93,131.93,0,0,1-.67,18.32c-.64,6.43-1.67,13.27-2.94,20.87-.65,3.8-1.33,7.76-2.09,12S906.56,356.18,905.6,361.09Zm-.48.58a40.33,40.33,0,0,1-4.31-6.8c-1.38-2.54-2.66-5.37-3.92-8.34a150.57,150.57,0,0,1-6.59-19.83A181,181,0,0,1,886,304.33l-.35-2.89a20,20,0,0,1-.2-2.91,18,18,0,0,1,1.18-6.1,21.7,21.7,0,0,1,3.72-6.24,27.11,27.11,0,0,1,7.36-6.16l.33-.41,19.37-2h.05l.36.34a27.05,27.05,0,0,1,3.88,4.78,37.77,37.77,0,0,1,2.65,4.89,38.75,38.75,0,0,1,2.87,10c.27,1.68.38,3.38.52,5.08s.26,3.4.36,5.1c.22,3.39.35,6.8.44,10.21q.24,10.23-.48,20.55c-.24,3.44-.58,6.89-1,10.35a96.59,96.59,0,0,1-1.9,10.43l-.09.38-.24,0C918.22,360.45,911.64,361.07,905.12,361.67Z",
    transform: "translate(-393.93 -44.36)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 452.02,
    y: 88.75,
    width: 393.95,
    height: 565.83,
    rx: 33.97,
    transform: "translate(930.39 648.64) rotate(175.65)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 470.15,
    y: 100.16,
    width: 380.98,
    height: 546.84,
    rx: 24.34,
    transform: "translate(953.81 651.6) rotate(175.65)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 737.39,
    y: 478.9,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(1187.1 944.89) rotate(175.65)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 524.08,
    y: 161.94,
    width: 128.1,
    height: 128.1,
    rx: 24.34,
    transform: "translate(797.79 362.33) rotate(175.65)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 651.38,
    y: 484.17,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(1015.72 961.95) rotate(175.65)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 565.53,
    y: 491.98,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(844.86 984.05) rotate(175.65)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 724.39,
    y: 332.9,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(1150.06 654.3) rotate(175.65)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 638.38,
    y: 338.17,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(978.68 671.35) rotate(175.65)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 552.53,
    y: 345.98,
    width: 68.65,
    height: 91.53,
    rx: 13.51,
    transform: "translate(807.82 693.46) rotate(175.65)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 570.68,
    y: 72.13,
    width: 114.37,
    height: 43.79,
    rx: 8.46,
    transform: "translate(-399.25 3.55) rotate(-4.35)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 232.46,
    cy: 30.24,
    r: 29.73
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 671.31,
    y: 262.36,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-412.03 11.28) rotate(-4.35)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 669.84,
    y: 243.06,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-410.57 11.12) rotate(-4.35)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 664.07,
    y: 171.19,
    width: 103.81,
    height: 7.45,
    rx: 3.6,
    transform: "translate(-405.14 10.47) rotate(-4.35)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 331.87,
    cy: 177.68,
    r: 63.63
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 751.54,
    y: 304.75,
    width: 117.78,
    height: 8.74,
    rx: 3.6,
    transform: "translate(-8.14 -491.57) rotate(39.81)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 846.37,
    cy: 337.89,
    rx: 10.55,
    ry: 10.18,
    transform: "translate(-109.47 1011) rotate(-73.7)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 232.94,
    y1: 123.7,
    x2: 155.34,
    y2: 231.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.82,
    y1: 137.94,
    x2: 241.74,
    y2: 221.72
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 183.38,
    y1: 465.5,
    x2: 229.46,
    y2: 524.54
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 229.46,
    y1: 462.62,
    x2: 190.58,
    y2: 530.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 267.19,
    y1: 457.78,
    x2: 313.27,
    y2: 516.82
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 313.27,
    y1: 454.9,
    x2: 274.39,
    y2: 522.58
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 359.34,
    y1: 452.79,
    x2: 405.42,
    y2: 511.83
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 405.42,
    y1: 449.91,
    x2: 366.54,
    y2: 517.59
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 165.38,
    y1: 317.5,
    x2: 211.46,
    y2: 376.54
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 211.46,
    y1: 314.62,
    x2: 172.58,
    y2: 382.3
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 249.19,
    y1: 309.78,
    x2: 295.27,
    y2: 368.82
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 295.27,
    y1: 306.9,
    x2: 256.39,
    y2: 374.58
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 341.34,
    y1: 304.79,
    x2: 387.42,
    y2: 363.83
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 387.42,
    y1: 301.91,
    x2: 348.54,
    y2: 369.59
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1237.84,312.44",
    transform: "translate(-393.93 -44.36)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M726.92,638.77c1.22,4.09-41.81,26.55-97,33.82-12.81,1.69-87.66,11.56-96-11.24-6.45-17.61,26.28-56,57.6-55.82,25.89.15,31.25,26.52,68.1,36.45C696.16,651.82,725.9,635.35,726.92,638.77Z",
    transform: "translate(-393.93 -44.36)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M726.92,628.77c1.22,4.09-41.81,26.55-97,33.82-12.81,1.69-87.66,11.56-96-11.24-6.45-17.61,26.28-56,57.6-55.82,25.89.15,31.25,26.52,68.1,36.45C696.16,641.82,725.9,625.35,726.92,628.77Z",
    transform: "translate(-393.93 -44.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmnoresults);
export default __webpack_public_path__ + "static/media/Admnoresults.4198c694774f0a3c408e590341963a1e.svg";
export { ForwardRef as ReactComponent };